import { isBooksyCom, useLogger } from '@booksy-com/vue-tools'
import moment from 'moment'
import Survicate from '@survicate/survicate-web-package/survicate_widget'

import { useCore } from '@/composables/core/index.js'
import { getBaseProperties } from '@/lib/analytics/helpers.js'
import { DEVICE } from '@/lib/analytics/consts.js'

import {
  camelToSnakeCase,
  transformAnalyticsDataToSurvicate,
} from './helpers.js'

import {
  WORKSPACE,
  EXCLUDED_ANALYTIC_EVENTS,
} from './consts.js'

import { useOnboardingStore } from '@/stores/onboarding/index.js'

const logger = useLogger('survicate')

const _getBaseVisitorTraits = () => {
  const { store: { state: { app, business, routingConfig, identity } } } = useCore()
  const onboardingStore = useOnboardingStore()

  const data = {
    appType: app.appType,
    business: business.business || onboardingStore.business,
    country: app.country,
    fingerprint: app.fingerprint,
    routingConfig: routingConfig.config,
    user: identity.user || onboardingStore.user,
    device: DEVICE[app.webView] || DEVICE.www,
  }

  const {
    logged_in_user_id,
    app_version,
    offer_type,
    device_type,
    logged_in_user_role,
    business_id,
    business_admin_status,
  } = getBaseProperties(data)

  const visitorTraits = {
    is_production: isBooksyCom() ? 'true' : 'false',
    user_id: logged_in_user_id,
    app_version,
    offer_type,
    device_type,
    country_code: data.routingConfig?.country.code,
    user_role: logged_in_user_role,
    business_id,
    business_admin_status,
    business_category: data.business.primary_category_internal_name,
    business_created: business.business ? moment(business.business.active_from).format('YYYY-MM-DD') : null,
    staffer_number: business.business ? business.business.active_staffers_count : null,
    app_type: 'frontdesk',
    boost_status: business.business ? business.business.boost_status : null,
  }

  return visitorTraits
}

let isInitialized = false
export function initSurvicate () {
  if (isInitialized) return

  Survicate.init({ workspaceKey: WORKSPACE })
  isInitialized = true

  logger.info('init')
}

export function useSurvicate () {
  const updateVisitorIdentity = () => {
    Survicate.setVisitorTraits(_getBaseVisitorTraits())
    Survicate.retarget()

    logger.info('update visitor identity')
  }

  const invokeAnalyticsEvent = (name, data) => {
    if (!name || EXCLUDED_ANALYTIC_EVENTS.includes(name)) return

    Survicate.invokeEvent(
      camelToSnakeCase(name, false),
      transformAnalyticsDataToSurvicate(data)
    )

    logger.info(`invoke analytics event - ${name}`)
  }

  return {
    updateVisitorIdentity,
    invokeAnalyticsEvent,
  }
}
